import useAuth from "../../../hooks/authenticate/useAuth";
import useConfig from "../../../hooks/useConfig";
import clsx from "clsx";
import axios from "../../../api/axios";
import { useState, useEffect, useReducer, useLayoutEffect, useMemo } from "react";
import { subDays, startOfToday, endOfDay, eachWeekendOfInterval, startOfYesterday, endOfYesterday, startOfMonth, subMonths, endOfMonth } from "date-fns";

// import MultiInOutBarChart from "./MultiInOutBarChartComponent";
import useInterval from "@rooks/use-interval";
import GeneralMainMap from "../GeneralMainMap";
// import GeneralPieChart from "./GeneralPieChart";
// import GeneralMultiLineChart from "./GeneralMultiLineChart";
import convertDeviceIds from "../../../utils/getAsciiIds";
// import GeneralStackedBar from "./GeneralStackedBar";
import { addId } from "../../../redux/slices/reportsSlice";
import { useSelector, useDispatch } from "react-redux";
import AtarimLinechart from "./AtarimLineChart";
import AtarimDonutTextchart from "./AtarimDonutTextChart";
import AtarimStackedBarchart from "./AtarimStackedBarChart";
import AtarimRadialchart from "./AtarimRadialChart";
import { AtarimRushHour } from "./AtarimRushHour";
import AtarimOccupancyLinechart from "./AtarimOccupancyLineChart";
import { currentOccupancyDayKey, occupancyDayKey } from "./occupancyDay";
import AtarimHeatmapChart from "./AtarimHeatmapChart";
import AtarimKpiCards from "./AtarimKpiCards";
var request_updateTimelineData_safe = true;
var request_updateBalance_safe = true;

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}

/**
 * Most recent fully completed Sun–Sat week(s).
 * Search ends at end-of-yesterday so "today's Saturday" is never treated as closed.
 * Returns { weekSun, weekSat, priorWeekSun, priorWeekSat }.
 */
function getCompletedSunSatWeeks({ lookbackDays = 28, includePrior = false } = {}) {
  const end = endOfYesterday();
  const start = subDays(end, lookbackDays);
  const weekends = eachWeekendOfInterval({ start, end });

  let weekSun;
  let weekSat;
  let priorWeekSun;
  let priorWeekSat;

  for (let i = weekends.length - 1; i >= 0; i--) {
    const d = weekends[i];
    if (!weekSun || !weekSat) {
      if (d.getDay() === 0 && weekSat) {
        weekSun = d;
      } else if (d.getDay() === 6) {
        weekSat = endOfDay(d);
      }
    } else if (includePrior && (!priorWeekSun || !priorWeekSat)) {
      if (d.getDay() === 0 && priorWeekSat) {
        priorWeekSun = d;
      } else if (d.getDay() === 6) {
        priorWeekSat = endOfDay(d);
      }
    } else {
      break;
    }
  }

  return { weekSun, weekSat, priorWeekSun, priorWeekSat };
}

function getDatesOfWeek(date) {
  const dayOfWeek = date.getDay();
  const diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 0); // find first day of the week (Monday)
  const weekStart = new Date(date.setDate(diff));
  const weekDates = [new Date(weekStart.setHours(2, 0, 0, 0))];
  for (let i = 1; i <= 7; i++) {
    const d = new Date(weekStart);
    d.setDate(weekStart.getDate() + i);
    weekDates.push(d.toISOString());
  }
  return weekDates;
}
function findHourData(timeline, hour) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return timeline[i];
    }
  }
  return -1;
}
function fillHourData(timeline, hour, ids) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      let time = timeline[i];
      for (let j = 1; j <= ids; j++) {
        let count = time[j];
        if (!Number.isInteger(count)) {
          time[j] = 0;
        }
      }
      return time;
    }
  }
  return -1;
}

function margeSameHours(timeline) {
  let temp = [];
  for (let i = 0; i < timeline.length; i++) {
    let currentChecker = timeline[i];

    for (let j = i + 1; j < timeline.length; j++) {
      if (
        parseInt(timeline[i]["hour"].split(":")[0]) ===
        parseInt(timeline[j]["hour"].split(":")[0])
      ) {
        currentChecker["inCount"] += timeline[j]["inCount"];
        currentChecker["outCount"] += timeline[j]["outCount"];
        currentChecker["total"] += timeline[j]["total"];
      }
    }
    temp.push(currentChecker);
  }
  return temp;
}
function mergeData(timeline) {
  let temp = [];
  let set = new Set();
  for (let i = 0; i < timeline.length; i++) {
    if (!set.has(i)) {
      let currentChecker = timeline[i];
      // console.log(i);
      // if (!set.has(i)) {
      // console.log(currentChecker["hour"]);
      // set.add(i);
      currentChecker[currentChecker["id"]] = currentChecker["total"];
      for (let j = i + 1; j < timeline.length; j++) {
        if (
          parseInt(currentChecker["hour"].split(":")[0]) ===
          parseInt(timeline[j]["hour"].split(":")[0])
        ) {
          set.add(j);

          let id = timeline[j]["id"];
          currentChecker[id] = timeline[j]["total"];

          currentChecker["total"] =
            currentChecker["total"] < timeline[j]["total"]
              ? timeline[j]["total"]
              : currentChecker["total"];
          // console.log(currentChecker["total"]);
        }
      }
      temp.push(currentChecker);
    }
  }
  // console.log(temp);
  return temp;
}

function fillLine(timeline) {
  let temp = [];

  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  if (timeline.length > 0)
    for (let i = 0; i < new Date().getHours(); i++) {
      let hour = i < 10 ? `0${i}:00` : `${i}:00`;
      let res = findHourData(timeline, hour);
      if (res !== -1) {
        temp.push(res);
      } else {
        temp.push({
          hour: hour,
          deviceId: timeline[0].deviceId,
          inCount: 0,
          outCount: 0,
          total: 0,
        });
      }
    }
  return temp;
}
function fillTotalLine(timeline, ids) {
  let temp = [];

  if (timeline.length > 0)
    for (let i = 0; i < new Date().getHours(); i++) {
      let hour = i < 10 ? `0${i}:00` : `${i}:00`;
      let res = fillHourData(timeline, hour, ids);
      if (res !== -1) {
        temp.push(res);
      } else {
        let obj = {
          hour: hour,
          total: 0,
        };
        for (let j = 1; j <= ids; j++) {
          obj[j] = 0;
        }
        temp.push(obj);
      }
    }
  return temp;
}
const devicesReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_DATA":
      return { ...action.data };
    case "UPDATE_MAP":
      return {
        ...state,
        map: action.payload.map,
        totalTimeline: action.payload.totalTimeline,
        totalPieData: action.payload.totalPieData,
      };
    case "UPDATE_ACTIVE_DEVICE":
      let { id, inCount, outCount, timelineData } = state.map.get(
        action.payload
      );
      return {
        ...state,
        activeDevice: {
          id: id,
          device: action.payload,
          pieData: { inCount: inCount, outCount: outCount },
          timeline: timelineData,
        },
        activeAll: null,
      };
    case "ACTIVE_ALL_DATA":
      return {
        ...state,
        activeDevice: null,
        activeAll: {
          description: "סה״כ תעבורה יומי",
          pieData: { ...state.totalPieData },
          timeline: state.totalTimeline,
        },
      };
    default:
      return state;
  }
};
function removeDuplicates(arr, dateProp) {
  const unique = new Map();
  arr.forEach((obj) => {
    const date = obj[dateProp];
    if (!unique.has(date)) {
      unique.set(date, obj);
    }
  });
  return Array.from(unique.values());
}
const AtarimCombinedComponents = () => {
  const { config } = useConfig();
  const { auth } = useAuth();
  const [timelineData, setTimelineData] = useState([]);
  const [weeklyTimeLineData, setWeeklyTimelineData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingBalance, setLoadingBalance] = useState(true);
  const [totalCountVehicles, setTotalCountVehicles] = useState(0);
  const [deviceListData, dispatch] = useReducer(devicesReducer, {});
  const [deviceList, setDeviceList] = useState([]);
  const [sum, setSum] = useState(0);
  const [deviceNames, setDeviceNames] = useState(["כניסה ראשית"]);
  const [lineDeviceName, setLineDeviceName] = useState(deviceNames[0]);
  const [occupancyLineDeviceName, setOccupancyLineDeviceName] = useState(deviceNames[0]);
  const [lineDataByDuration, setLineDataByDuration] = useState([]);
  const [occupancyLineDataByDuration, setOccupancyLineDataByDuration] = useState([]);
  const [dataByDuration, setDataByDuration] = useState([]);
  const [donutDataByDuration, setDonutDataByDuration] = useState([]);
  const [donutDeviceName, setDonutDeviceName] = useState(deviceNames[0]);
  const [monthlyRushHourData, setMonthlyRushHourData] = useState([]);
  const [weeklyRushHourData, setWeeklyRushHourData] = useState([]);
  const [weeklyVisitorsRushHourData, setWeeklyVisitorsRushHourData] = useState([]);
  const [weeklyVisitorsTrend, setWeeklyVisitorsTrend] = useState(null);
  const [hourlyRushHourData, setHourlyRushHourData] = useState([]);
  const [locationRushHourData, setLocationRushHourData] = useState([]);
  const dispatchid = useDispatch();
  const selectId = useSelector((state) => state);

  // handleResize
  var deviceIdss = convertDeviceIds(deviceList);

  const colorGraph = [
    "#b317a7",
    "#2317b3",
    "#b31724",
    "#1777b3",
    "#77b317",
    "#b0ad12",
    "#b31778",
    "#6817b3",
    "#b31743",
  ];
  const colorTexts = [
    "text-pink-900",
    "text-blue-900",
    "text-red-900",
    "text-cyan-900",
    "text-lime-900",
    "text-yellow-900",
  ];
  function clickEventHandler(deviceId) {
    dispatch({ type: "UPDATE_ACTIVE_DEVICE", payload: deviceId });
  }
  function clickEventAllHandler(deviceId) {
    dispatch({ type: "ACTIVE_ALL_DATA", payload: deviceId });
  }

  useEffect(() => {
    function getParkingList() {
      let sensorNames = [];
      let obj = {
        devices: [],
        map: new Map(),
        activeDevice: null,
        activeAll: null,
      };
      let devices = config.areas.forEach((area) => {
        area.devices.forEach((device) => {
          let map = obj["map"];

          sensorNames.push(device["name"]);
          map.set(device["deviceId"], { 
            ...device,
            inCount: 0,
            outCount: 0,
          });
          obj["devices"].push(device["deviceId"]);
          obj["map"] = map;
        });
      });
      dispatch({ type: "ADD_DATA", data: obj });
      setDeviceNames((prev) => sensorNames);
      setDeviceList((prev) => obj["devices"]);
    }
    getParkingList();

    // setLoading(false);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function updateBalance() {
    // console.log(request_updateTimelineData_safe);
    if (request_updateBalance_safe === false) {
      return;
    } else {
      request_updateBalance_safe = false;
    }
    axios.get(`/v1/balance?token=${auth.token}`).then((res) => {
      let data = res.data.flat();
      if (data.length > 0) {
        data = data.sort((a, b) => {
          return new Date(b["date"]).getTime() - new Date(a["date"]).getTime();
        });
        let sum = data[0]["sum"];
        // console.log("finished balance");
        setSum((prev) => sum);
        setLoadingBalance(false);
        request_updateBalance_safe = true;
      } else {
        setSum((prev) => 0);
        setLoadingBalance(false);
        request_updateBalance_safe = true;
      }
    });
  }
  
  function getWeeklyStatistics() {
    axios
      .get(
        `/v1/statistics/daily?token=${
          auth.token
        }&date=${new Date()}&areas=${null}&id=${convertDeviceIds(
          deviceList
        )}&data=InOut`
      )
      .then((res) => {
        let data = res.data;
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            let obj = {
              Entering: 0,
              Leaving: 0,
              Total: 0,
            };
            obj["date"] = data[i]["date"];
            // console.log(obj["date"]);
            // console.log(obj["day"]);

            Object.entries(data[i]["day"]).forEach((v, k) => {
              obj["Entering"] =
                Object.values(v[1])
                  .map((val) => {
                    return val["inCount"];
                  })
                  .reduce((a, b) => a + b) + obj["Entering"];
              obj["Leaving"] =
                Object.values(v[1])
                  .map((val) => {
                    return val["outCount"];
                  })
                  .reduce((a, b) => a + b) + obj["Leaving"];
              obj["Total"] =
                Object.values(v[1])
                  .map((val) => {
                    return val["outCount"] > val["inCount"]
                      ? val["outCount"]
                      : val["inCount"];
                  })
                  .reduce((a, b) => a + b) + obj["Total"];
            });
            data[i] = obj;
          }
          data = removeDuplicates(data, "date");
          console.log(data,"datas");
          setWeeklyTimelineData((prev) => data);
        }
      });
  }

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/hour?token=${
          auth.token
        }&day=${new Date().getUTCDate()}&month=${
          new Date().getUTCMonth() + 1
        }&areas=${null}`
      )
      .then((res) => {
        let timelineData = [];
        let reducerData = new Map();
        let reduceAllData = {};
        let totalTimeline = [];
        for (let i = 0; i < deviceList.length; i++) {
          reducerData.set(deviceList[i], {
            id: i + 1,
            inCount: 0,
            outCount: 0,
            timelineData: [],
          });
          reduceAllData[i + 1] = 0;
        }
        let totalVehicles = sum;
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (
              new Date(res.data[i][j]["date"]).getHours() <=
              new Date().getHours()
            ) {
              let deviceId = res.data[i][j]["deviceId"];
              // let data = resData[deviceData];
              let totalInOut = (res.data[i][j]["inCount"] || 0) + (res.data[i][j]["outCount"] || 0);
              let percentageIn = totalInOut > 0 ? (res.data[i][j]["inCount"] || 0) / totalInOut : 0;
              let percentageOut = totalInOut > 0 ? (res.data[i][j]["outCount"] || 0) / totalInOut : 0;
              let data = reducerData.get(deviceId);

              let inCount = totalInOut > 0 ? Math.ceil(percentageIn * (res.data[i][j]["totalCount"] || 0)) : (res.data[i][j]["inCount"] || 0);
              data["inCount"] = (data["inCount"] || 0) + inCount;

              let outCount = totalInOut > 0 ? Math.floor(percentageOut * (res.data[i][j]["totalCount"] || 0)) : (res.data[i][j]["outCount"] || 0);
              data["outCount"] = (data["outCount"] || 0) + outCount;
              data["timelineData"].push({
                hour: getLocalHour(res.data[i][j]["date"]),
                deviceId: res.data[i][j]["deviceId"],
                inCount: inCount,
                outCount: outCount,
                total: inCount > outCount ? inCount : outCount,
              });
              totalTimeline.push({
                hour: getLocalHour(res.data[i][j]["date"]),
                id: data["id"],
                total: inCount > outCount ? inCount : outCount,
              });
              reduceAllData[data["id"]] =
                reduceAllData[data["id"]] + inCount + outCount;

              reducerData.set(res.data[i][j]["deviceId"], data);
              totalVehicles += inCount - outCount;
              timelineData.push({
                hour: getLocalHour(res.data[i][j]["date"]),
                deviceId: res.data[i][j]["deviceId"],
                inCount: inCount,
                outCount: outCount,
                total: inCount > outCount ? inCount : outCount,
              });
              // resData[deviceData] = data;
            }
          }
        }
        // console.log(reducerData);
        // console.log(totalVehicles);
        // TODO: need to check if this if needed
        for (let i = 0; i < deviceList.length; i++) {
          let data = reducerData.get(deviceList[i]);
          data["timelineData"] = fillLine(data["timelineData"]);
          // data["timelineDataTotal"] = fillLine(data["timelineDataTotal"]);
          reducerData.set(deviceList[i], data);
        }
        timelineData = margeSameHours(timelineData);
        timelineData = fillLine(timelineData);
        totalTimeline = mergeData(totalTimeline);
        totalTimeline = fillTotalLine(totalTimeline, 5);

        setTimelineData((prev) => timelineData);
        if (totalCountVehicles !== totalVehicles && !loadingBalance) {
          if (totalVehicles <= 0) {
            let demiTotal = -Math.floor(sum / 3);
            setTotalCountVehicles((prev) => demiTotal);
          } else {
            setTotalCountVehicles((prev) => totalVehicles);
          }
        }
        dispatch({
          type: "UPDATE_MAP",
          payload: {
            map: reducerData,
            totalTimeline: totalTimeline,
            totalPieData: reduceAllData,
          },
        });
        if (loading) {
          dispatch({ type: "ACTIVE_ALL_DATA", payload: "" });
        }
        setLoading(false);
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
  }

  function updateTimeBasedOccupancyLineData(forceFresh = false) {
    let entering = "", leaving = "", date = "";
    if (!forceFresh && occupancyLineDataByDuration.length !== 0) {
        ({ entering, leaving, date } = occupancyLineDataByDuration[occupancyLineDataByDuration.length - 1]);        
    }

    let url = `/v1/statistics/occupancy?token=${auth.token}&dataDuration=7D`;
    if (!forceFresh && date && entering !== "" && leaving !== "") {
        url += `&lastEntering=${entering}&lastLeaving=${leaving}&lastDate=${date}`;
    }

    axios.get(url).then(res => {
        if (res.data && res.data.result) {
            setOccupancyLineDataByDuration(res.data.result);
        }
    }).catch(err => console.error(err));
  }

  const currentOccupancy = useMemo(() => {
    if (!occupancyLineDataByDuration || occupancyLineDataByDuration.length === 0) return 0;

    // Operational plaza day: 04:00 Israel → next 04:00 (not calendar midnight).
    const todayKey = currentOccupancyDayKey();

    let cumToday = 0;
    let foundToday = false;
    occupancyLineDataByDuration.forEach(item => {
      const dateStr = occupancyDayKey(item._id || item.date);
      if (dateStr === todayKey) {
        foundToday = true;
        const net = (item.occupancy !== undefined ? item.occupancy : (item.entering - item.leaving) || 0);
        cumToday = Math.max(0, cumToday + net);
      }
    });

    return foundToday ? Math.max(0, cumToday) : 0;
  }, [occupancyLineDataByDuration]);

  const todayStats = useMemo(() => {
    const todayStr = new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Jerusalem" });
    let totalPerson = 0;
    let totalMicro = 0;

    dataByDuration.forEach(deviceData => {
      (deviceData?.result || []).forEach(record => {
        if (record.date) {
          const recDay = new Date(record.date).toLocaleDateString("sv-SE", { timeZone: "Asia/Jerusalem" });
          if (recDay === todayStr) {
            totalPerson += (record.entering_person !== undefined ? record.entering_person : record.entering) || 0;
            totalMicro += (record.entering_micromobility || 0);
          }
        }
      });
    });

    return {
      person: totalPerson,
      micromobility: totalMicro,
      total: totalPerson + totalMicro
    };
  }, [dataByDuration]);

  function updateTimeBasedLineData(forceFresh = false) {
    let entering = "", leaving = "", date = "";
    if (!forceFresh && lineDataByDuration.length !== 0) {
        ({ entering, leaving, date } = lineDataByDuration[lineDataByDuration.length - 1]);        
    }
    const locIdx = deviceNames.indexOf(lineDeviceName);
    if (locIdx === -1) return;

    let url = `/v1/statistics/range?token=${auth.token}&dataDuration=7D&location=${locIdx}`;
    if (!forceFresh && date && entering !== "" && leaving !== "") {
        url += `&lastEntering=${entering}&lastLeaving=${leaving}&lastDate=${date}`;
    }

    axios.get(url).then(res => {
        if (res.data && res.data.result) {
            setLineDataByDuration(res.data.result);
        }
    }).catch(err => console.error(err));
  }

  function updateTimeBasedData(date) {
    if (!date || !date.from || !date.to) return;
    const toDate = endOfDay(date.to);
    Promise.all(deviceNames.map((deviceName, i) => axios.get(`/v1/statistics/range?token=${auth.token}&dateRangeFrom=${date.from}&dateRangeTo=${toDate}&location=${i}`)))
      .then((responses) => setDataByDuration(responses.map(r => r.data)))
      .catch(err => console.error(err));
  }

  function updateTimeBasedDonutData() {
    const locIdx = deviceNames.indexOf(donutDeviceName);
    if (locIdx === -1) return;
    axios.get(`/v1/statistics/range?token=${auth.token}&dataDuration=21D&location=${locIdx}`).then(res => {
      if (res.data && res.data.result) {
        setDonutDataByDuration(res.data.result);
      }
    }).catch(err => console.error(err));
  }

  useEffect(() => {

    function getTimeBasedMonthlyVisitorRushData() {
      const previousMonthStartDate = startOfMonth(subMonths(new Date(), 1));
      const previousMonthEndDate = endOfMonth(subMonths(new Date(), 1));
      axios.get(`/v1/statistics/rushHour/visitors?dateRangeFrom=${previousMonthStartDate}&dateRangeTo=${previousMonthEndDate}`).then(res => setMonthlyRushHourData(res.data.result[0].entering)).catch(err => console.error(err))
    }

    function getTimeBasedWeeklyVisitorsRushData() {
      const { weekSun, weekSat, priorWeekSun, priorWeekSat } = getCompletedSunSatWeeks({
        lookbackDays: 28,
        includePrior: true,
      });

      if (weekSun && weekSat) {
        axios.get(`/v1/statistics/rushHour/visitors?dateRangeFrom=${weekSun}&dateRangeTo=${weekSat}`)
          .then(res => {
            const currentWeekly = res.data?.result?.[0]?.entering || 0;
            setWeeklyVisitorsRushHourData(currentWeekly);

            if (priorWeekSun && priorWeekSat) {
              axios.get(`/v1/statistics/rushHour/visitors?dateRangeFrom=${priorWeekSun}&dateRangeTo=${priorWeekSat}`)
                .then(resPrior => {
                  const priorWeekly = resPrior.data?.result?.[0]?.entering || 0;
                  if (priorWeekly > 0) {
                    const diff = Math.round(((currentWeekly - priorWeekly) / priorWeekly) * 100);
                    setWeeklyVisitorsTrend(diff);
                  }
                }).catch(err => console.error(err));
            }
          }).catch(err => console.error(err));
      }
    }

    function getTimeBasedWeeklyRushData() {
      const { weekSun, weekSat } = getCompletedSunSatWeeks({ lookbackDays: 14 });
      if (!weekSun || !weekSat) return;
      axios.get(`/v1/statistics/rushHour?dateRangeFrom=${weekSun}&dateRangeTo=${weekSat}`).then(res => setWeeklyRushHourData(res.data.result)).catch(err => console.error(err))
    }

    function getTimeBasedLastDayRushData() {      
      axios.get(`/v1/statistics/rushHour?dateRangeFrom=${startOfYesterday()}&dateRangeTo=${endOfYesterday()}`).then(res => setHourlyRushHourData(res.data.result)).catch(err => console.error(err))
    }

    function getTimeBasedLocationDayRushData() {   
      const { weekSun, weekSat } = getCompletedSunSatWeeks({ lookbackDays: 14 });
      if (!weekSun || !weekSat) return;
      axios.get(`/v1/statistics/rushHour/location?dateRangeFrom=${weekSun}&dateRangeTo=${weekSat}`).then(res => setLocationRushHourData(res.data.result)).catch(err => console.error(err))
    }
    getTimeBasedMonthlyVisitorRushData();
    getTimeBasedWeeklyVisitorsRushData();
    getTimeBasedWeeklyRushData();
    getTimeBasedLastDayRushData();
    getTimeBasedLocationDayRushData();

    
  }, []);


  useEffect(() => {
    // setTimeout(() => {
      if (deviceList.length > 0) {
        updateTimelineData();
        updateTimeBasedOccupancyLineData();
        updateBalance();
        getWeeklyStatistics();
      }
    // }, 100);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceList, sum, totalCountVehicles]);

  useEffect(() => {
    updateTimeBasedLineData(true);
  }, [lineDeviceName]);

  useEffect(() => {
    updateTimeBasedOccupancyLineData(true);
  }, [occupancyLineDeviceName]);

  useEffect(() => {
    updateTimeBasedDonutData();
  }, [donutDeviceName]);

  useInterval(
    () => {
      // updateBalance();
      updateTimelineData();
      updateTimeBasedOccupancyLineData(false);
    },
    loading || loadingBalance ? 250 : 3000,
    true
  );
  useInterval(
    () => {
    //   updateBalance();
    updateTimeBasedLineData(false);
      // updateTimelineData();
    },
    loading || loadingBalance ? 250 : 20001,
    true
  );
  useEffect(() => {
    dispatchid(addId(parseInt(deviceIdss)));
  }, [deviceIdss ? deviceIdss : null]);
  
  if (loading || loadingBalance) {
    return (
      // <div className="w-full h-full flex flex-col items-center justify-evenly p-4 shadow-xl  backdrop-blur-xl  bg-blue-900 bg-opacity-30  rounded-xl ">
      <div className="bg-gray-300 flex-col h-full w-full rounded-md overflow-hidden transition-all self-baseline ">
        <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
      </div>
      // </div>
    );
  }
  return (
    // <div className="w-full h-full flex flex-row items-center justify-evenly p-3   shadow-xl  backdrop-blur-xl  bg-blue-100 bg-opacity-20  rounded-xl ">
    //   <div className="w-2/3 h-full">
    //     <div className="w-full h-1/2 flex flex-col gap-2 px-2">
    //       <section className="w-full h-1/2 flex flex-col">
    //         <MultiInOutBarChart
    //           device={["inCount", "outCount"]}
    //           data={timelineData}
    //           colorGraph={[colorGraph[0], colorGraph[1]]}
    //           textDesc={["כניסות", "יציאות"]}
    //           colorText={[colorTexts[0], colorTexts[1]]}
    //           generalDescription={" כניסות ויציאות שעתי כולל של היום"}
    //           XAxisValue={"hour"}
    //           hours={"true"}
    //         />
    //       </section>
    //       {console.log(weeklyTimeLineData,"week")}
    //       <section className="w-full h-1/2 flex flex-col">
    //         <GeneralStackedBar
    //           timelineData={weeklyTimeLineData}
    //           values={["Entering"]}
    //           colors={[colorGraph[0]]}
    //           textDesc={["כניסות"]}
    //           colorText={[colorTexts[0]]}
    //           generalDescription={"כניסות 7 ימים אחורה"}
    //         />
    //       </section>
    //     </div>
    //     <div className="w-full h-1/2 p-2  ">
    //       <GeneralMainMap
    //         areas={config.areas[0]}
    //         // token={auth.token}
    //         mapConfig={config.map}
    //         colors={colorGraph}
    //         shape="CIRCLES"
    //         onClickHandler={clickEventHandler}
    //         buttonDesc="לצפייה בהכל לחץ כאן"
    //         onAllClickHandler={clickEventAllHandler}
    //       />
    //     </div>
    //   </div>
    //   <div className="w-1/2 h-full py-4 px-2">
    //     <div className=" h-1/6 flex flex-col bg-hatachana bg-no-repeat bg-blend-screen items-center  rounded-md p-2">
    //       <div className="bg-white text-xl p align-top sticky top-0  px-2 shadow-lg rounded-md">
    //         תפוסה נוכחית
    //       </div>
    //       {/* <div className=" align-middle self-center flex flex-col bg-transparent rounded-3xl p-4  items-center "> */}
    //       {totalCountVehicles !== 0 ? (
    //         <div className="items-center sticky content-center self-center justify-self-center py-2">
    //           <div className="flex text-center justify-center  bg-white rounded-xl p-2  align-middle self-center ">
    //             {totalCountVehicles}
    //           </div>
    //         </div>
    //       ) : (
    //         <div className="items-center sticky content-center self-center justify-self-center py-2">
    //           <div className="flex text-center justify-center  bg-white rounded-xl p-2  align-middle self-center animate-pulse ">
    //             .. טוען
    //           </div>
    //         </div>
    //       )}
    //       {/* </div> */}
    //     </div>
    //     {deviceListData.activeDevice && deviceNames.length > 0 ? (
    //       <div className="w-full h-5/6 flex flex-col items-center justify-center">
    //         <div className="text-lg">
    //           סנסור {deviceListData.activeDevice["id"]}
    //         </div>
    //         <div className="w-full h-1/2">
    //           <GeneralMultiLineChart
    //             values={["inCount", "outCount"]}
    //             data={deviceListData.activeDevice["timeline"]}
    //             colorGraph={[colorGraph[0], colorGraph[1], colorGraph[2]]}
    //             textDesc={["כניסות", " יציאות", "סה״כ"]}
    //             colorText={[colorTexts[0], colorTexts[1], colorTexts[2]]}
    //             generalDescription={"מידע שעתי יומי"}
    //             XAxisValue={"hour"}
    //             hours={"true"}
    //           />
    //         </div>
    //         <div className="w-full h-1/2 flex items-center">
    //           <GeneralPieChart
    //             pieData={deviceListData.activeDevice["pieData"]}
    //             pieDesc={["כניסות", "יציאות"]}
    //             colors={[colorGraph[0], colorGraph[1]]}
    //             generalDescription={"אחוז יחסי כניסות ויציאות"}
    //           />
    //         </div>
    //       </div>
    //     ) : deviceListData.activeAll && deviceNames.length > 0 ? (
    //       <div className="w-full h-5/6 flex flex-col pt-1 items-center justify-center">
    //         <div className="w-full h-1/2">
    //           <GeneralMultiLineChart
    //             values={["1", "2", "3", "4", "5", "6"]}
    //             data={deviceListData.activeAll["timeline"]}
    //             colorGraph={[
    //               colorGraph[0],
    //               colorGraph[1],
    //               colorGraph[2],
    //               colorGraph[3],
    //               colorGraph[4],
    //               colorGraph[5]
    //             ]}
    //             textDesc={deviceNames}
    //             colorText={[
    //               colorTexts[0],
    //               colorTexts[1],
    //               colorTexts[2],
    //               colorTexts[3],
    //               colorTexts[4],
    //               colorTexts[5]
    //             ]}
    //             generalDescription={"מידע שעתי יומי"}
    //             XAxisValue={"hour"}
    //             hours={"true"}
    //           />
    //         </div>
    //         <div className="w-full h-1/2 flex items-center">
    //           <GeneralPieChart
    //             pieData={deviceListData.activeAll["pieData"]}
    //             pieDesc={deviceNames}
    //             colors={[
    //               colorGraph[0],
    //               colorGraph[1],
    //               colorGraph[2],
    //               colorGraph[3],
    //               colorGraph[4],
    //             ]}
    //             generalDescription={"אחוז יחסי כניסות ויציאות"}
    //           />
    //         </div>
    //       </div>
    //     ) : (
    //       <div className="w-full h-5/6 flex flex-col items-center justify-center">
    //         <div className="bg-white text-2xl p-10 shadow-xl rounded-xl">
    //           אנא בחרו סנסור מהמפה
    //         </div>
    //       </div>
    //     )}
    //   </div>
    // </div>
    <>
      <div className="flex flex-col w-full">
        {/* Top: 5 Executive KPI Metric Cards */}
        <AtarimKpiCards
          currentOccupancy={currentOccupancy}
          todayStats={todayStats}
          hourlyRushHourData={hourlyRushHourData}
          locationRushHourData={locationRushHourData}
          location={locationRushHourData?.[0]?._id ? (deviceNames[deviceList.indexOf(locationRushHourData[0]._id)] || "") : ""}
          weeklyVisitorsRushHourData={weeklyVisitorsRushHourData}
          weeklyVisitorsTrend={weeklyVisitorsTrend}
          monthlyRushHourData={monthlyRushHourData}
        />

        {/* Row 1 (60 / 40): Daily Stacked Bar Chart (60%) + Weekly Day-of-Week Heatmap Chart (40%) */}
        <div className="flex flex-col lg:flex-row w-full space-y-4 lg:space-y-0 lg:space-x-4 mb-4">
          <div className="w-full lg:w-3/5">
            <div className="p-1 h-full">
              <AtarimStackedBarchart deviceNames={deviceNames} dataByDuration={dataByDuration} updateTimeBasedData={updateTimeBasedData} />
            </div>
          </div>

          <div className="w-full lg:w-2/5 overflow-x-auto">
            <div className="p-1 h-full text-center">
              <AtarimHeatmapChart deviceNames={deviceNames} dataByDuration={dataByDuration} />
            </div>
          </div>
        </div>

        {/* Row 2 (3 Columns): Site Occupancy Line Chart (1/3) + Gate In/Out Flow Line Chart (1/3) + Donut Distribution (1/3) */}
        <div className="flex flex-col lg:flex-row w-full space-y-4 lg:space-y-0 lg:space-x-4">
          <div className="w-full lg:w-1/3 overflow-x-auto">
            <div className="p-1 text-center h-full">
              <AtarimOccupancyLinechart occupancyLineDataByDuration={occupancyLineDataByDuration} />
            </div>
          </div>

          <div className="w-full lg:w-1/3 overflow-x-auto">
            <div className="p-1 text-center h-full">
              <AtarimLinechart data={lineDataByDuration} deviceNames={deviceNames} lineDeviceName={lineDeviceName} setLineDeviceName={setLineDeviceName} occupancyLineDataByDuration={occupancyLineDataByDuration} />
            </div>
          </div>

          <div className="w-full lg:w-1/3 overflow-x-auto">
            <div className="p-1 text-center h-full">
              <AtarimDonutTextchart data={donutDataByDuration} deviceNames={deviceNames} donutDeviceName={donutDeviceName} setDonutDeviceName={setDonutDeviceName} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AtarimCombinedComponents;
